export default {

    probabilityMeasureTypes: 'Probability Measures',
    editProbabilityMeasureTypesError: 'Error editing probability measures',
    updateProbabilityMeasureTypesSuccess: 'Probability measures updated successfully',
    editLoaderProbabilityMeasureTypes: 'Updating probability measures...',
    getProbabilityMeasureTypesError: 'Error fetching probability measures',
    rangeOrderError: 'The order range is incorrect',
    probabilityOcurrence: 'Probability of Occurrence',
    probabilityMeasureDescription: 'On this section you can define the value of the probability of occurrence associated with a risk.',
    probabilityMeasureGuide: 'Define the probability values associated with each risk in this section.',

}